import { Component, Inject, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { FilterStateKeys, INew_TableAction, New_TableFilters } from '@lla-platform/core/core-data-access'
import { UntilDestroy } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
  selector: 'lla-overview-filters-dialog',
  templateUrl: './overview-filters-dialog.component.html',
  styleUrls: ['./overview-filters-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class OverviewFiltersDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<OverviewFiltersDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      advancedFilterKey: FilterStateKeys
      tableActions: INew_TableAction
      tableFilters: New_TableFilters
      filters: string[]
    }
  ) {}
}
